import config from 'react-global-configuration';
// eslint-disable-next-line no-unused-vars
import { ThunkAction } from 'redux-thunk';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
var qs = require('qs');

// TODO: Turn these into separate actions?
export var VIEW_ACTION_REPLACE = 'replace';
export var VIEW_ACTION_APPEND = 'append';

/**
 * Load data for a given view.
 *
 * @param {string} viewId - The view id
 * @param {string} displayId - The view display id.
 * @param {?number} [page] - The current page. Leave empty to let the pager decide.
 * @param {array} [args] - Contextual filter arguments
 * @param {Object} [filters] - Exposed filter arguments
 * @param {string} [action] - Action te perform after fetching view data
 * @param {boolean} [referenceLoading] - Use reference loading redux states.
 * @param {boolean} [loadAllPages] - Use reference loading redux states.
 *
 * @returns {ThunkAction} - Redux thunk
 */
export var viewGet = function viewGet(viewId, displayId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var action = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : VIEW_ACTION_REPLACE;
  var referenceLoading = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  var loadAllPages = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  return function (dispatch, getState) {
    if (referenceLoading) {
      dispatch(referenceLoadingStart());
    }
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'view']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    var url = "".concat(PATH, "/entity/view/").concat(viewId, "/").concat(displayId, "/results?_format=json");
    if (typeof page !== 'undefined' && page !== null) {
      url += "&page=".concat(page);
    }
    if (Array.isArray(args) && args.length > 0) {
      var encodedArgs = args.map(function (item) {
        return "args[]=".concat(item);
      }).join('&');
      url = "".concat(url, "&").concat(encodedArgs);
    }
    if (Object.keys(filters).length > 0) {
      var _encodedArgs = qs.stringify({
        filters: filters
      });
      url = "".concat(url, "&").concat(_encodedArgs);
    }
    fetch(url, {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(viewGetLoaded(viewId, displayId, response, action));
      if (loadAllPages && response.pager) {
        var next = 1 + (response.pager.current_page || 0);
        var total = response.pager.total_pages || 1;
        if (next < total) {
          dispatch(viewGet(viewId, displayId, next, args, filters, VIEW_ACTION_APPEND, referenceLoading, loadAllPages));
        } else if (referenceLoading) {
          dispatch(referenceLoadingDone());
        }
      } else if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }
    }).catch(function () {
      if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }
    });
  };
};
export var VIEW_GET_LOADED = 'VIEW_GET_LOADED';
export function viewGetLoaded(viewId, displayId, data, action) {
  return {
    type: VIEW_GET_LOADED,
    viewId: viewId,
    displayId: displayId,
    data: data,
    action: action
  };
}
export var viewGetInfo = function viewGetInfo(viewId) {
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var url = "".concat(PATH, "/entity/view/").concat(viewId, "/info?_format=json");
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'view']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch(url, {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(viewGetInfoLoaded(viewId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var VIEW_GET_INFO_LOADED = 'VIEW_GET_INFO_LOADED';
export function viewGetInfoLoaded(viewId, viewInfo) {
  return {
    type: VIEW_GET_INFO_LOADED,
    payload: {
      viewId: viewId,
      viewInfo: viewInfo
    }
  };
}